/* -----------------Globals--------------- */
import { Pressable } from "react-native";

import Icon from "@expo/vector-icons/MaterialCommunityIcons";
/* -----------------UI--------------- */
import { Text, TextInput } from "react-native-paper";

import { useAppTheme } from "../../../useAppTheme";
/* -----------------Child components--------------- */
import Box from "../../Box";
import { useToggleCommandbar } from "./useToggleCommandbar";

type Props = {
	handleTrackEvent: () => void;
};
const CommandbarContainer = ({ handleTrackEvent }: Props) => {
	const toggleCommandbar = useToggleCommandbar();
	const theme = useAppTheme();

	const handlePress = () => {
		handleTrackEvent();
		toggleCommandbar();
	};

	const handleFocus = () => {
		toggleCommandbar();
	};

	return (
		<Pressable
			onPress={handlePress}
			onFocus={handleFocus}
			style={{
				cursor: "pointer",
			}}
			accessibilityRole="search"
		>
			<TextInput
				placeholder="Search..."
				accessibilityLabel="Command bar"
				accessibilityHint="Activate to search or use commands"
				mode="outlined"
				textColor={theme.colors.onSurfaceVariant}
				placeholderTextColor={theme.colors.onSurfaceVariant}
				style={{
					backgroundColor: theme.colors.surfaceVariant,
					height: 42,
					minWidth: 360,
				}}
				outlineStyle={{
					borderWidth: 0,
					borderRadius: 28,
				}}
				left={
					<TextInput.Icon
						icon="magnify"
						color={theme.colors.onSurfaceVariant}
						style={{
							backgroundColor: "transparent",
						}}
						onPress={handlePress}
					/>
				}
				right={
					<TextInput.Icon
						style={{
							backgroundColor: "transparent",
						}}
						icon={() => {
							return (
								<Box flexDirection="row" alignItems="center" gap={4}>
									<Icon
										color={theme.colors.onSurfaceVariant}
										name="apple-keyboard-command"
										size={16}
									/>
									<Text
										style={{
											color: theme.colors.onSurfaceVariant,
										}}
										variant="labelLarge"
									>
										K
									</Text>
								</Box>
							);
						}}
						onPress={handlePress}
					/>
				}
			/>
		</Pressable>
	);
};

export default CommandbarContainer;
